import React, { useState } from 'react';

// DevExtreme components
import { Tooltip } from 'devextreme-react/tooltip';

export function LightToolTip(props) {
  const [isVisible, setIsVisible] = useState(false);
  let id = Math.random().toString(16).slice(2);

  return (
    <div>
      {React.cloneElement(props.children, {
        id: ("target" + id),
        onMouseEnter: () => setIsVisible(true),
        onMouseLeave: () => setIsVisible(false)
      })}
      <Tooltip
        target={"#target" + id}
        visible={isVisible}
        closeOnOutsideClick={true}
      >
        {props.title}
      </Tooltip>
    </div>
  );
}